// @flow

import React from 'react';

type Props = {
  seconds: number;
}

const timeInMinutes = (curtime: number): string => {
  const minutes = Math.floor(curtime / 60);
  const seconds = `0${curtime - (minutes * 60)}`;
  return `${minutes} : ${seconds.substr(-2)}`;
};

const Timer = (props: Props) => (
  <div className="chase__timer">
    <div className="chase__timer-text">{timeInMinutes(props.seconds)}</div>
  </div>
);

export default Timer;
